import {
  gracePeriodOptionsDictionary,
  disruptedNotificationsOptionsDictionary,
} from 'src/shared/entities/escrow-notification-options';
import { getEscrowActivityNotificationOptions } from 'src/shared/entities/escrow-activity-notification-options';

const { activityNotificationOptionsDictionary } = getEscrowActivityNotificationOptions('continuity');

export type ITechnicalField =
  | 'beneficiarySharedInformation'
  | 'beneficiaryActivityNotification'
  | 'beneficiaryDisruptionNotification'
  | 'beneficiaryDisruptionNotificationGracePeriod'
  | 'depositorActivityNotification'
  | 'depositorDisruptionNotification'
  | 'depositorDisruptionNotificationGracePeriod'
  | 'activationNotification';

export const getTechnicalSuggestedChangesItems = <K extends ITechnicalField, V extends string | boolean | number>(
  key: K,
  value: V,
) => {
  const keyToMessage = {
    beneficiarySharedInformation: {
      label: 'Environment visibility updated',
      value: typeof value === 'boolean' && value ? 'Show environment' : 'Hide environment',
    },
    beneficiaryActivityNotification: {
      label: 'Activity notification updated',
      value: activityNotificationOptionsDictionary[value as keyof typeof activityNotificationOptionsDictionary],
    },
    beneficiaryDisruptionNotification: {
      label: 'Disruption notification updated',
      value: disruptedNotificationsOptionsDictionary[value as keyof typeof disruptedNotificationsOptionsDictionary],
    },
    beneficiaryDisruptionNotificationGracePeriod: {
      label: 'Disruption notification grace period updated',
      value: gracePeriodOptionsDictionary[value as keyof typeof gracePeriodOptionsDictionary]?.label ?? '-',
    },
    depositorActivityNotification: {
      label: 'Activity notification updated',
      value: activityNotificationOptionsDictionary[value as keyof typeof activityNotificationOptionsDictionary],
    },
    depositorDisruptionNotification: {
      label: 'Disruption notification updated',
      value: disruptedNotificationsOptionsDictionary[value as keyof typeof disruptedNotificationsOptionsDictionary],
    },
    depositorDisruptionNotificationGracePeriod: {
      label: 'Disruption notification grace period updated',
      value: gracePeriodOptionsDictionary[value as keyof typeof gracePeriodOptionsDictionary]?.label ?? '-',
    },
    activationNotification: {
      label: 'Activation notification updated',
      value: value ? 'Send' : 'Don’t send',
    },
  };

  return key in keyToMessage ? (keyToMessage[key] as { label: string; value: string }) : { label: '', value: '' };
};
